import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@pinup-teams/common';

import { AiChatFormComponent } from './ai-chat-form.component';

@Injectable()
export class AiChatFormDialog {
  #dialog = inject(DialogService);

  open(): DialogRef {
    return this.#dialog.open(AiChatFormComponent);
  }
}
